module.exports = __webpack_public_path__ + "static/media/8.ea67b5fe.jpeg";